import { render } from "./FilterChipUnknownType.vue?vue&type=template&id=05ec47bb&scoped=true"
import script from "./FilterChipUnknownType.vue?vue&type=script&lang=js"
export * from "./FilterChipUnknownType.vue?vue&type=script&lang=js"

import "./FilterChipUnknownType.vue?vue&type=style&index=0&id=05ec47bb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ec47bb"]])

export default __exports__